import { render } from "./BoundingBoxSizeHistogram.vue?vue&type=template&id=323f9b34&scoped=true"
import script from "./BoundingBoxSizeHistogram.vue?vue&type=script&lang=js"
export * from "./BoundingBoxSizeHistogram.vue?vue&type=script&lang=js"

import "./BoundingBoxSizeHistogram.vue?vue&type=style&index=0&id=323f9b34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323f9b34"]])

export default __exports__